import React from 'react';
import bg1 from '../img/envision/newsandevents/cards/eventimg1.jpg'; // Adjust the path according to your project structure
import bg2 from '../img/envision/newsandevents/cards/eventimg2.jpg'; // Adjust the path according to your project structure
import bg3 from '../img/envision/newsandevents/cards/eventimg3.jpg'; // Adjust the path according to your project structure
import { useNavigate } from "react-router-dom";

const Newscardsdata = () => {
    const navigate = useNavigate();
    return (
        <div style={{ marginTop: '90px' }}>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: 'rgb(5 134 162)' }}> News And </span> Events
            </h1>

            {/* First Row */}
            <div className="two-side-cards-container">
                <div className="card" style={{ position: 'relative' }}>
                    <h2 style={{ color: "#fff", fontWeight: 'bold', fontSize: '30px' }}>Collaborations</h2>
                    <div className="card-image">
                        <img src={bg1} alt="Image 2" />
                    </div>
                    <div className="card-hover-content">
                        <p> Enable continuous evolution of your products with rapid design, production, and refinement to stay ahead of changing market needs.</p>
                        <i
                            className="fas fa-arrow-right"
                            style={{
                                position: 'absolute',
                                top: '130%', // Vertically center the icon
                                right: '20px', // Adjust the distance from the right edge
                                transform: 'translateY(-50%)', // Adjust position for better alignment
                                fontSize: '24px', // Icon size
                                color: '#fff', // Arrow color
                                cursor: 'pointer', // Make the icon clickable
                                backgroundColor: 'rgb(5, 134, 162)', // Background color of the circle
                                borderRadius: '50%', // Makes the background a circle
                                padding: '10px', // Adds space around the icon inside the circle
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Optional: Add some shadow for the circle
                            }}
                            onClick={() => navigate('/automotivemobility')} // Direct redirection with useNavigate
                        />


                    </div>

                    {/* Arrow icon positioned at the right with inline redirection */}

                </div>

                <div className="card">
                    <h2 style={{ color: "#fff", fontWeight: 'bold', fontSize: '30px' }}>Premiers Awards</h2>
                    <div className="card-image">
                        <img src={bg2} alt="Image 2" />
                    </div>
                    <div className="card-hover-content">
                        <p> Enable continuous evolution of your products with rapid design, production, and refinement to stay ahead of changing market needs.</p>

                        <i
                            className="fas fa-arrow-right"
                            style={{
                                position: 'absolute',
                                top: '130%', // Vertically center the icon
                                right: '20px', // Adjust the distance from the right edge
                                transform: 'translateY(-50%)', // Adjust position for better alignment
                                fontSize: '24px', // Icon size
                                color: '#fff', // Arrow color
                                cursor: 'pointer', // Make the icon clickable
                                backgroundColor: 'rgb(5, 134, 162)', // Background color of the circle
                                borderRadius: '50%', // Makes the background a circle
                                padding: '10px', // Adds space around the icon inside the circle
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Optional: Add some shadow for the circle
                            }}
                            onClick={() => navigate('/automotivemobility')} // Direct redirection with useNavigate
                        />

                    </div>
                </div>

                <div className="card">
                    <h2 style={{ color: "#fff", fontWeight: 'bold', fontSize: '30px' }}>Patners with</h2>
                    <div className="card-image">
                        <img src={bg3} alt="Image 3" />
                    </div>
                    <div className="card-hover-content">
                        <p> Enable continuous evolution of your products with rapid design, production, and refinement to stay ahead of changing market needs.</p>
                        <i
                            className="fas fa-arrow-right"
                            style={{
                                position: 'absolute',
                                top: '130%', // Vertically center the icon
                                right: '20px', // Adjust the distance from the right edge
                                transform: 'translateY(-50%)', // Adjust position for better alignment
                                fontSize: '24px', // Icon size
                                color: '#fff', // Arrow color
                                cursor: 'pointer', // Make the icon clickable
                                backgroundColor: 'rgb(5, 134, 162)', // Background color of the circle
                                borderRadius: '50%', // Makes the background a circle
                                padding: '10px', // Adds space around the icon inside the circle
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Optional: Add some shadow for the circle
                            }}
                            onClick={() => navigate('/automotivemobility')} // Direct redirection with useNavigate
                        />


                    </div>
                </div>
            </div>

            {/* Additional Styles */}
            <style jsx>{`
                .two-side-cards-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 50px;
                    padding: 20px;
                    flex-wrap: wrap;
                }

                .card {
                    position: relative;
                    width: 303px;
                    height: 350px;
                    text-align: center;
                    background-color: #f0f0f0; /* Light background color */
                    border-radius: 8px;
                    overflow: hidden; /* Ensures content is contained within the card */
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Initial box-shadow */
                }

                .card:hover {
                    transform: scale(1.05); /* Slightly scale the card on hover */
                    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4); /* Increase box-shadow on hover */
                }

                .card h2 {
                    position: absolute;
                    bottom: 10px;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 20px;
                    color: rgb(5, 134, 162);
                    margin: 0;
                    z-index: 1; /* Ensures title is above the image */
                    transition: transform 0.3s ease, bottom 0.3s ease;
                }

                .card:hover h2 {
                    transform: translateX(-50%) translateY(-100%); /* Move title to top on hover */
                    bottom: auto; /* Remove bottom positioning */
                    top: 0px; /* Position title at the top */
                }

                .card-image img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 8px;
                }

                .card-hover-content {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    visibility: hidden;
                    opacity: 0;
                    text-align: center;
                    color: white;
                    transition: visibility 0s, opacity 0.3s linear;
                }

                .card:hover .card-hover-content {
                    visibility: visible;
                    opacity: 1;
                    width: 250px;
                }

                .card-hover-content p {
                    font-size: 16px;
                    font-weight: bold;
                    padding: 10px;
                    border-radius: 8px;
                }
            `}</style>
        </div>
    );
};

export default Newscardsdata;
